import React from "react"
import styled from "styled-components"
import { em } from "polished"
import { useCookies } from "react-cookie"

import Link from "../link"
import { ReactComponent as SvgExclamationCircle } from "../../assets/icons/exclamation-circle.svg"
import { ReactComponent as SvgDelete } from "../../assets/icons/delete.svg"

const GlobalNotice = ({ data, translations, Paragraph, Anchor }) => {
  const cookieName = data?.id || `global-notice`
  const [cookies, setCookie] = useCookies([cookieName])

  const closeClick = () => {
    setCookie(cookieName, true, { path: `/`, maxAge: 3600 * 24 * 30 })
  }

  if (
    typeof window === `undefined` ||
    !data ||
    !data.show ||
    !data.text ||
    !cookieName ||
    cookies[cookieName]
  )
    return null

  let link =
    data.relatedNews?.path ||
    data.relatedArticle?.path ||
    data.relatedEvents?.path
  const isLinkInternal = !!link
  link = link || data.link

  let text = data.text.trim()
  if (link && !data.text.trim().endsWith(`.`)) text += `.`

  return (
    <Container $level={data.level}>
      <Inner>
        <SvgExclamationCircleStyled aria-hidden="true" />

        <Info as={Paragraph}>
          {text}

          {link && (
            <>
              {` `}
              <Anchor
                as={Link}
                target={!isLinkInternal ? `_blank` : undefined}
                rel={!isLinkInternal ? `noopener noreferrer` : undefined}
                to={link}
              >
                {translations.global.showMore}
              </Anchor>
            </>
          )}
        </Info>

        <Close
          type="button"
          title={translations.global.close}
          onClick={closeClick}
        >
          <SvgDelete aria-label={translations.global.close} />
        </Close>
      </Inner>
    </Container>
  )
}

export default GlobalNotice

const Container = styled.div`
  padding: ${em(18)} 0;
  display: flex;
  justify-content: center;
  color: ${({ theme }) =>
    theme.components?.globalNotice?.borderColor || `#fff`};
  background-color: ${({ theme, $level }) =>
    theme.components?.globalNotice?.backgroundColor?.[$level] || `#000`};
`

const Inner = styled.div`
  ${({ theme }) => theme.grid.container()}

  display: flex;
  gap: ${em(20)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    gap: ${em(12)};
  }
`

const SvgExclamationCircleStyled = styled(SvgExclamationCircle)`
  width: ${em(18)};
  height: ${em(18)};
  margin-top: ${em(3)};
  flex-shrink: 0;
`

const Info = styled.p`
  && {
    color: inherit;
  }

  a {
    color: inherit;

    &:hover {
      color: inherit;
      opacity: 0.7;
    }

    &:active {
      opacity: 0.5;
    }
  }
`

const Close = styled.button`
  width: ${em(38)};
  height: ${em(38)};
  flex-shrink: 0;
  margin: ${em(-6)} 0;
  margin-right: ${em(-10)};
  margin-left: auto;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }

  svg {
    width: 100%;
    height: 100%;
    padding: ${em(12)};
    display: block;
  }
`
